<template>
  <div class="col-md-6 py-2 preview" :style="commonStyles">
    <div class="d-flex flex-row align-items-center justify-content-between mb-3">
      <h4>Preview</h4>
      <div>
        <div class="custom-control custom-switch">
          <input type="checkbox" class="custom-control-input" id="new_wf" v-model="new_wf">
          <label class="custom-control-label font-weight-normal no-select d-block" for="new_wf">New workflow</label>
        </div>
      </div>
    </div>

		<div class="p-4 preview-container card card-bordered w-100"
					v-show="!new_wf"
					v-bind:style="{ backgroundColor: styleSettings.page.backgroundColor, fontFamily: styleSettings.text.font, color: styleSettings.text.defaultColor }">
			<h5 v-bind:style="{ color: styleSettings.text.primaryColor}">Primary Color</h5>
			<div class="mb-2">
				<label for="previewInput" class="mt-4 form-label">This is input field title</label>
				<input type="text"
               class="form-control"
               name="previewInput"
               id="previewInput"
               placeholder="Placeholder text"
               v-model="serial"
               v-bind:style="{ borderColor: styleSettings.input.borderColor, backgroundColor: styleSettings.input.backgroundColor, color: styleSettings.text.secondaryColor}">
				<small v-bind:style="{ color: styleSettings.text.secondaryColor}">This text describes input field purpose</small>
			</div>
			<div class="form-submit">
				<button class="btn" v-bind:style="{ color: styleSettings.button.textColor, backgroundColor: styleSettings.button.backgroundColor, borderColor: styleSettings.button.textColor}">Submit</button>
			</div>
			<div class="footer-links mt-3">
				<span v-bind:style="{ color: styleSettings.text.secondaryColor}">© {{year}} InComm Payments</span>
				<a v-bind:style="{ color: styleSettings.text.defaultColor }" class="mr-2 ml-2" disabled="true">Contact Us</a>
				<a v-bind:style="{ color: styleSettings.text.defaultColor }" disabled="true">F.A.Q</a>
			</div>
		</div>


    <div class="p-3 preview-container card card-bordered rounded-0 w-100"
         v-show="new_wf"
         v-bind:style="{ backgroundColor: styleSettings.page.backgroundColor, fontFamily: styleSettings.text.font, color: styleSettings.text.defaultColor }">

      <div class="bg-white rounded-lg p-4">
        <h5 class="text-center" v-bind:style="{ color: styleSettings.text.primaryColor}">Add your card numbers</h5>
        <p class="text-center mb-4 pb-4" v-bind:style="{ color: styleSettings.text.primaryColor}">
          We can try to automatically recognize the barcode on your physical card so that you don't have to enter the code manually. To do this, click on the photo icon, take a photo of the back of your card with the barcode and upload it here. For a digital card, simply copy and paste the card number.</p>

        <div class="my-4 pb-5">
          <div class="position-relative overflow-hidden w-100">
            <input
                placeholder="########"
                autocomplete="off"
                type="text"
                data-1p-ignore
                class="serial-number my-0"
                v-model="serial"
            >
            <template v-if="!serial">
              <div class="position-absolute btn-upload">
                <span class="btn-upload__icon">
                  <i class="fa fa-camera text-black-20"/>
                </span>
              </div>
            </template>
            <template v-else>
              <div class="btn-save">
                Save
              </div>
            </template>
          </div>
          <div class="row justify-md-content-between mt-2">
            <div class="col-12">
              <span role="button" aria-label="Where is my card number?"
                    class="form-label cursor-pointer font-weight-bold"
              >
                Where is my card number?
              </span>
            </div>
          </div>
        </div>

        <div class="form-submit text-center mt-4">
          <button
              class="btn wizard-btn"
              v-bind:style="{ color: styleSettings.button.textColor, backgroundColor: styleSettings.button.backgroundColor, borderColor: styleSettings.button.textColor}">Next</button>
        </div>

        <div class="footer-links mt-5 py-4 my-4 px-2 border-top border-bottom">
          <div class="text-center mb-4">
            <img :src="incommLogo" alt="InComm Payments" width="130">
          </div>
          <div class="d-flex align-items-center justify-content-center">
            <a v-bind:style="{ color: styleSettings.text.defaultColor }" class="py-1" disabled="true">Contact Us</a>
            <a v-bind:style="{ color: styleSettings.text.defaultColor }" class="py-1 border-left border-right px-3 mx-3" disabled="true">Privacy Policy</a>
            <a v-bind:style="{ color: styleSettings.text.defaultColor }" class="py-1" disabled="true">FAQ</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import incommLogo from 'images/incomm-logo';

export default {
  name: 'previewWindow',
  props: ['styleSettings'],

  data() {
    return {
      serial: '',
      new_wf: false,
      incommLogo: incommLogo,
    }
  },

  computed: {
    year() {
      return new Date().getFullYear();
    },
    commonStyles() {
      return {
        '--text-color': this.styleSettings.text.primaryColor,
        '--placeholder': this.styleSettings.input.placeholderColor,
        '--primary-button-bg': this.styleSettings.button.backgroundColor,
        '--primary-button-color': this.styleSettings.button.textColor,
        '--input-border':  this.styleSettings.input.borderColor,
        '--input-background': this.styleSettings.input.backgroundColor,
        '--input-color': this.styleSettings.input.secondaryColor,
      }
    }
  }
}
</script>

<style scoped>
  @import url('https://fonts.googleapis.com/css?family=Montserrat:400,400i,700,700i|Open+Sans:400,400i,700,700i|Roboto:400,400i,700,700i');

  .wizard-btn {
    padding: 10px 24px;
    border: none !important;
    border-radius: 4px;

    &:hover {
      opacity: .8;
    }
  }

  .serial-number {
    width: 100%;
    border: 1px solid var(--input-border);
    background-color: var(--input-background);
    color: var(--text-color);

    border-radius: 4px;
    font-size: 15px;
    padding: 12px;

    &:focus, &:focus-within, &:focus-visible {
      border-color: v-bind(styleSettings.text.defaultColor) !important;
      outline: none;

      & + .btn-upload {
        .btn-upload__icon {
          border-color: v-bind(styleSettings.text.defaultColor) !important;
        }

        .fa {
          color: v-bind(styleSettings.text.defaultColor) !important;
        }
      }
    }
  }

  .btn-save {
    position: absolute;
    top: 2px;
    right: 2px;
    background: v-bind(styleSettings.input.backgroundColor);
    height: calc(100% - 4px);
    line-height: 45px;
    padding: 0 0.5em;
    border-radius: 4px;
  }

  .btn-upload {
    position: absolute;
    width: 40px;
    height: 100%;
    top: 0;
    right: 0;

    .fa {
      color: rgba(0, 0, 0, 0.2);
    }

    .btn-upload__icon {
      position: absolute;
      width: calc(100% - 2px);
      height: calc(100% - 8px);
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border: none;
      color: rgba(0, 0, 0, 0.2);
      font-size: 16px;
      cursor: pointer;
      top: 4px;
      border-radius: 0;
      background: v-bind(styleSettings.input.backgroundColor);
      border-left: 1px solid v-bind(styleSettings.input.borderColor);
    }
  }

  ::placeholder {
    color: var(--placeholder) !important;
  }

  ::-webkit-input-placeholder {
    color: var(--placeholder) !important;
  }

  :-moz-placeholder {
    color: var(--placeholder) !important;
  }

  ::-moz-placeholder {
    color: var(--placeholder) !important;
  }

  :-ms-input-placeholder {
    color: var(--placeholder) !important;
  }

  label,
  button{
    font-weight: bold;
  }

  button{
    font-weight: 700;
    font-size: 13px;
  }

  h5{
    font-weight: 700;
    font-size: 18px;
  }

  .preview-container{
    position: sticky;
    top: 160px;
    margin-top: -6px;
    height: max-content;
  }

  .custom-control-label {
    padding-top: 2px;
  }
</style>
